export default __webpack_public_path__ + "static/presentation-video-56dffe702181f272b66a4ef76a385f91.mp4";